import { useQuery } from '@tanstack/react-query';
import { AuditEventDto, fetchAuditEvents } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useAuditEvents = (publisherId: string) =>
  useQuery({
    queryFn: async () => {
      const response = await extractData(
        fetchAuditEvents({
          query: {
            EntityType: 'Publisher',
            EntityId: parseInt(publisherId, 10),
            SortingExpressions: '-eventTime',
            PageNumber: 1,
            PageSize: 1000,
          },
        })
      );
      return (response.page?.items || []) as Array<
        AuditEventDto & { id: number }
      >;
    },
    queryKey: ['auditEvents', publisherId],
  });
